/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as MsDyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { useState } from 'react';
import AuthContainer from './components/auth-container';
import DeliveryDetails from './components/delivery-details';
import DeliverySummary from './components/delivery-summary';
import LoopBanner from './components/loop-banner';
import { ILxsAnonymousDeliveryViewProps } from './lxs-anonymous-delivery';
import { IAnonymousDeliveryOrder } from './mocks/lxs-anonymous-delivery.mock-data';

const LxsAnonymousDeliveryView: React.FC<ILxsAnonymousDeliveryViewProps> = ({ resources, localizationState, context, config }) => {
    const CLASS_NAME = 'lxs-anonymous-delivery';
    const [order, setOrder] = useState<IAnonymousDeliveryOrder | undefined>(undefined);

    const { loopImage } = config;

    if (order) {
        return (
            <>
                <DeliverySummary CLASS_NAME={CLASS_NAME} order={order} resources={resources} localizationState={localizationState} />
                <DeliveryDetails
                    CLASS_NAME={CLASS_NAME}
                    events={order.events}
                    mainCarriage={order.mainCarriage}
                    resources={resources}
                    localizationState={localizationState}
                    context={context}
                />

                <div className={`${CLASS_NAME}__loop-banner ${loopImage ? `${CLASS_NAME}__loop-banner--with-image` : ''}`}>
                    <div className={`${CLASS_NAME}__loop-content`}>
                        <LoopBanner
                            CLASS_NAME={CLASS_NAME}
                            resources={resources}
                            loopRegistrationLink={config.loopRegistrationLink}
                            linkAriaLabel={resources.lxsAnonymousDeliveryLoopRegistration}
                            linkTitle={resources.lxsAnonymousDeliveryLoopRegistration}
                        />
                    </div>

                    {loopImage && (
                        <div className={`${CLASS_NAME}__loop-image`}>
                            <MsDyn365.Image
                                {...loopImage}
                                className={`${CLASS_NAME}__loop-image-img`}
                                gridSettings={context.request.gridSettings!}
                                imageSettings={loopImage.imageSettings}
                                shouldSkipToMainImage
                            />
                        </div>
                    )}
                </div>
            </>
        );
    }

    return (
        <AuthContainer
            CLASS_NAME={CLASS_NAME}
            resources={resources}
            actionContext={context.actionContext}
            loopRegistrationLink={config.loopRegistrationLink}
            onOrderFound={setOrder}
        />
    );
};

export default LxsAnonymousDeliveryView;
